import React, { createContext, useContext, useState } from "react";

interface GlobalFolderContextType {
  selectedFolderId: string | null;
  setSelectedFolderId: (folderId: string | null) => void;
}

const GlobalFolderContext = createContext<GlobalFolderContextType | undefined>(undefined);

export const useGlobalFolderContext = () => {
  const context = useContext(GlobalFolderContext);
  if (context === undefined) {
    throw new Error('useGlobalFolderContext must be used within a GlobalFolderProvider');
  }
  return context;
};

interface GlobalFolderProviderProps {
  children: React.ReactNode;
}

export const GlobalFolderProvider: React.FC<GlobalFolderProviderProps> = ({
  children,
}) => {
  const [selectedFolderId, setSelectedFolderId] = useState<string | null>(null);

  const value = {
    selectedFolderId,
    setSelectedFolderId,
  };

  return (
    <GlobalFolderContext.Provider value={value}>
      {children}
    </GlobalFolderContext.Provider>
  );
};
